module.exports = __webpack_public_path__ + "static/media/1015193.393bc308.jpg";